import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "radio-group-container w-full mt-3"
}
const _hoisted_2 = { class: "input-label mb-3 lg:mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*", -1)
const _hoisted_4 = { class: "grid md:grid-cols-2 gap-2 lg:gap-8 w-full" }
const _hoisted_5 = { class: "relative flex items-center w-full" }
const _hoisted_6 = ["value", "checked"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "flex items-center w-full gap-3" }
const _hoisted_10 = ["value", "checked"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "checkmark" }, null, -1)
const _hoisted_12 = { class: "flex items-center gap-4" }
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "w-fit bg-primary/10 text-primary text-xs font-semibold leading-tight rounded-full px-2 py-1" }, " Najczęściej wybierane ", -1)
const _hoisted_15 = { class: "flex flex-row gap-3" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "bg-secondary/10 text-secondary text-xs font-semibold leading-tight rounded-full px-4 flex items-center justify-center min-w-fit" }

import { computed } from 'vue';



export default {
  __name: 'VariationsField',
  props: {
  selectedVariation: {
    type: Number,
    required: true,
  },
  variations: {
    type: Array,
    required: true,
  },
  selectVariation: {
    type: Function,
    required: false,
  },
  name: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const priceDifference = computed(() => {
  if (props.variations && props.variations.length >= 2) {
    // Konwersja cen na liczby; jeśli wartość nie jest liczbą, to przypisujemy 0
    const price1 = Number(props.variations[0].display_price) || 0;
    const price2 = Number(props.variations[1].display_price) || 0;
    const diff = price2 - price1;
    return diff > 0 ? `+ ${diff} zł` : `${diff} zł`;
  }
  return '';
});

return (_ctx, _cache) => {
  return (__props.variations.length === 2)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.name || 'Typ') + " ", 1),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            class: _normalizeClass([
          'radio-button form-radio-button px-6 py-8 md:px-[16px] md:py-[48px] !items-center rounded-3xl border-[1px] border-greyScale-100',
          { 'bg-white shadow-feature': __props.selectedVariation === __props.variations[0].variation_id }
        ]),
            onClick: _cache[0] || (_cache[0] = $event => (__props.selectVariation(__props.variations[0].variation_id)))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                type: "radio",
                value: __props.variations[0].variation_id,
                checked: __props.selectedVariation === __props.variations[0].variation_id
              }, null, 8, _hoisted_6),
              _hoisted_7,
              _createElementVNode("div", {
                class: "ml-4",
                innerHTML: __props.variations[0].variation_description
              }, null, 8, _hoisted_8)
            ])
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass([
    'radio-button !items-center form-radio-button px-4 py-4 md:px-6 md:py-6 rounded-3xl border border-greyScale-100',
    { 'bg-white shadow-feature': __props.selectedVariation === __props.variations[1].variation_id }
  ]),
            onClick: _cache[1] || (_cache[1] = $event => (__props.selectVariation(__props.variations[1].variation_id)))
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "radio",
                value: __props.variations[1].variation_id,
                checked: __props.selectedVariation === __props.variations[1].variation_id
              }, null, 8, _hoisted_10),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: "text-base font-medium leading-tight",
                      innerHTML: __props.variations[1].variation_description
                    }, null, 8, _hoisted_16),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(priceDifference)), 1)
                  ])
                ])
              ])
            ])
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}